module.exports = function getResource(label, vars = []) {
    const resources = {
        canApply: `Vous pouvez maintenant appliquer *${vars[0]} points* à votre achat pour`,
        canApplyUpTo: `Vous pouvez maintenant utiliser jusqu’à *${vars[0]} points* pour`,
        missingPointsClose: `Il ne vous manque que *${vars[0]} point${vars[0] !== 1 ? 's' : ''}* pour avoir droit à une *réduction de ${vars[1]}*.`,
        onceYouEarn: `Quand vous aurez accumulé *${vars[0]} points*, vous pourrez les appliquer à votre pour profiter d’une *réduction de ${vars[1]}*.`,
        cashWillApplyHere: 'Vos dollars Beauty Insider seront affichés ici.',
        applyInBasket: 'Appliquer dans le panier',
        shopToEarnPoints: 'Magasiner pour accumuler des points',
        BICash: 'Dollars Beauty Insider',
        BICashOptions: 'Options dollars Beauty Insider',
        off: 'de réduction'
    };
    return resources[label];
};
